import { lazyLoad } from "utils";

export const IndividualCompliancePageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.IndividualCompliancePage
);
